import { createActionGroup, props } from '@ngrx/store';
import { GetPropertyViewingAvailabilitiesResponseModel } from '../../../shared/models/properties/property-availability.models';
import { GetUserViewingAvailabilitiesResponseModel } from '../../../shared/models/users/user-availability.models';
import {
  SelectedWeeksModel,
  SetCalendarWidgetDateModel,
  SetCalendarWidgetSettingsModel, SetCalendarWidgetTimeModel,
  SetHostDetailsModel,
  SetHostIdModel,
  SetIsHostedBySellerModel, SetIsLoadingDistanceModel, SetSelectedDateModel
} from '../../models/calendar-widget.model';
import { GetUserAppointmentsResponseModel } from '../../../shared/models/users/users.models';
import { GetDistancesByPropertiesResponseModel } from '../../../shared/models/google/google-maps.models';

export const CalendarWidgetActions = createActionGroup({
  source: 'CALENDAR',
  events: {
    'Set Calendar Widget settings': props<SetCalendarWidgetSettingsModel>(),
    'Init Calendar Widget': null,
    'Set Host Id': props<SetHostIdModel>(),
    'Set Host Details': props<SetHostDetailsModel>(),
    'Set Is Hosted By Seller': props<SetIsHostedBySellerModel>(),
    'Set Selected Date': props<SetSelectedDateModel>(),
    'Load User Viewing Availability': null,
    'Set User Viewing Availability': props<GetUserViewingAvailabilitiesResponseModel>(),
    'Load Property First Viewing Availability': null,
    'Load Property Viewing Availability Failure': null,
    'Load Property Viewing Availability': null,
    'Set Property Viewing Availability': props<GetPropertyViewingAvailabilitiesResponseModel>(),
    'Set Calendar Widget Date': props<SetCalendarWidgetDateModel>(),
    'Set Calendar Widget Time': props<SetCalendarWidgetTimeModel>(),
    'Load User Appointments': null,
    'Load User Appointments Success': props<GetUserAppointmentsResponseModel>(),
    'Load Distance Calculation': props<GetUserAppointmentsResponseModel>(),
    'Load Distance Calculation Success': props<GetDistancesByPropertiesResponseModel>(),
    'Set Selected Calendar Weeks': props<SelectedWeeksModel>(),
    'Load User Appointments For Selected Weeks': null,
    'Process User Appointments': props<GetUserAppointmentsResponseModel>(),
    'Set Is Loading Distance': props<SetIsLoadingDistanceModel>()
  }
});